import { useEffect } from "react";
import { toast } from "react-toastify";

export function useNetworkBanner() {
  useEffect(() => {
    const handleOffline = () =>
      toast.error("You are offline. Check your connection.", {
        toastId: "net-off",
      });

    const handleOnline = () => {
      toast.dismiss("net-off"); // remove the offline toast
      toast.success("Back online!", {
        hideProgressBar: true,
        position: "top-center",
        autoClose: 3000,
      });
    };

    window.addEventListener("offline", handleOffline);
    window.addEventListener("online", handleOnline);

    return () => {
      window.removeEventListener("offline", handleOffline);
      window.removeEventListener("online", handleOnline);
    };
  }, []);
}
